import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { WatchlistStudent } from '../../types/models/WatchlistStudentModel';
import { WATCHLIST } from './Actions';

export interface IWatchlistState {
  watchlist: WatchlistStudent[];
  watchlistLoading: boolean;
  watchlistSaving: boolean;
  watchlistError: string | undefined;
}

const initialState: IWatchlistState = {
  watchlist: [],
  watchlistLoading: false,
  watchlistSaving: false,
  watchlistError: undefined,
};

const watchlistReducer = createReducer(initialState, {
  [WATCHLIST.LOAD_BY_COMPANY]: (state) => {
    state.watchlistLoading = true;
    state.watchlistError = undefined;
  },
  [WATCHLIST.LOADED]: (state, action: PayloadAction<WatchlistStudent[]>) => {
    state.watchlistLoading = false;
    state.watchlist = action.payload;
    state.watchlistError = undefined;
  },
  [WATCHLIST.LOAD_ERROR]: (state, action: PayloadAction<string>) => {
    state.watchlistLoading = false;
    state.watchlistError = action.payload;
  },
  [WATCHLIST.SAVE]: (state) => {
    state.watchlistSaving = true;
    state.watchlistError = undefined;
  },
  [WATCHLIST.SAVED]: (state, action: PayloadAction<WatchlistStudent>) => {
    state.watchlistSaving = false;
    state.watchlist = [...state.watchlist, action.payload];
    state.watchlistError = undefined;
  },
  [WATCHLIST.SAVE_ERROR]: (state, action: PayloadAction<string>) => {
    state.watchlistSaving = false;
    state.watchlistError = action.payload;
  },
  [WATCHLIST.DELETE_SUCCESS]: (state, action: PayloadAction<string>) => {
    state.watchlist = state.watchlist.filter((x) => x.id !== action.payload);
  },
  [WATCHLIST.LOAD_BY_STUDENT]: (state) => {
    state.watchlistLoading = true;
    state.watchlistError = undefined;
  },
  [WATCHLIST.CONVERT]: (state) => {
    state.watchlistSaving = true;
    state.watchlistError = undefined;
  },
  [WATCHLIST.CONVERT_SUCCESS]: (state, action: PayloadAction<string>) => {
    state.watchlistSaving = false;
    state.watchlist = state.watchlist.filter((x) => x.id !== action.payload);
  },
  [WATCHLIST.CONVERT_ERROR]: (state, action: PayloadAction<string>) => {
    state.watchlistSaving = false;
    state.watchlistError = action.payload;
  },
});

export default watchlistReducer;